import { put, select, takeLatest } from 'redux-saga/effects'
import { DestinationAddressConstants } from '../store/destinationAddress.constants'
import {
  resetDestinationAddressStateOnTypeChange,
  setCensusTract,
  setReceivingMD,
  setZip,
  setState,
} from '../store/destinationAddress.actions'
import { IDispositionState } from '../store/destinationAddress.types'
import { getDestinationAddressSelector } from '../selectors/destinationAddress.selectors'
import { clearValidationErrorsByPathList } from '../../../utilities/runRulesValidation.util'
import { getRulesSelector } from '../../rules/selectors'
import { IRulesState } from '../../rules/store/rules.types'

export function* destinationAddressTypeChange() {
  const rules: IRulesState = yield select(getRulesSelector)
  const destinationAddress: IDispositionState = yield select(getDestinationAddressSelector)
  const { destination } = destinationAddress

  if (destination?.zip) {
    yield put(setZip(''))
  }
  if (destination?.censusTract) {
    yield put(setCensusTract(''))
  }
  if (destinationAddress?.receivingMdText) {
    yield put(setReceivingMD(''))
  }
  if (destination?.state) {
    yield put(setState(null))
  }

  yield put(resetDestinationAddressStateOnTypeChange())
  rules.errors = clearValidationErrorsByPathList(rules.errors, ['destinationAddress'])
}

export function* destinationAddressTypeChangeSaga() {
  yield takeLatest([DestinationAddressConstants.SET_TYPE], destinationAddressTypeChange)
}
